import getLocationRouterSelect from 'modules/router/selectors/get-location'
import getSearchRouterSelect from 'modules/router/selectors/get-search'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import getPathWithQueryLocationUtil from 'modules/location/utils/get-path-with-query'
import { logUtil } from 'packages/src'
import pushRouterAction from 'modules/router/actions/push'

export default function updateQueryParameterSearchAction (query) {
  return (dispatch, getState) => {
    const location = getLocationRouterSelect(getState())
    const search = getSearchRouterSelect(getState())

    const queryParams = getQueryParamsFromStringObjectUtil(search)
    const debugProps = { queryParams, query }
    logUtil('updateQueryParameterSearchAction').debug('debugProps=', debugProps)

    if (queryParams.q === query) {
      logUtil('updateQueryParameterSearchAction').debug('[noop] same query')
      return
    }

    const newQueryParams = {
      ...queryParams,
      q: query
    }

    const pathname = location.pathname
    const searchPath = getPathWithQueryLocationUtil(pathname, newQueryParams)
    logUtil('updateQueryParameterSearchAction').debug(`searchPath=${searchPath}`)
    dispatch(pushRouterAction(searchPath))
  }
}
